import { useEffect } from 'react';

import { usePostHog } from 'posthog-js/react';

import useLoginContext from '@/context/LoginFlowContextProvider/useLoginContext';

export default function PostHogBridge() {
  const posthog = usePostHog();
  const { currentUser, currentAccount, isAuthenticated } = useLoginContext();

  useEffect(() => {
    if (!posthog || window.opener) return;

    if (isAuthenticated && currentUser) {
      posthog.identify(currentUser.id, {
        email: currentUser.email,
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        userId: currentUser.id,
        accountName: currentAccount?.name,
        accountId: currentAccount?.id
      });
    } else if (!isAuthenticated) {
      posthog.reset();
    }
  }, [posthog, currentUser, isAuthenticated, currentAccount]);

  return null;
}
